import { PureComputed } from 'knockout';
import WCCContentContext from '../context';
import WCCContentDocument from '../document';

export default abstract class WCCContentRule {
    disabled: PureComputed<boolean>

    constructor() {
        this.disabled = ko.pureComputed(() => this.checkIfDisabled());
    }

    abstract parse(document: WCCContentDocument, context: WCCContentContext): WCCContentDocument

    protected checkIfDisabled() {
        return false;
    }
}

    